export const isEveryRequiredFieldFilled = (valueArray: Record<string, any>, ...requiredFields: string[]): boolean => {
    let fieldsFilled = true;

    requiredFields.forEach((field) => {
        if (!valueArray[field]) {
            fieldsFilled = false;
        }
    });
    return fieldsFilled;
};
